import { render, staticRenderFns } from "./myScore.vue?vue&type=template&id=82b9eb34&scoped=true&"
import script from "./myScore.vue?vue&type=script&lang=js&"
export * from "./myScore.vue?vue&type=script&lang=js&"
import style0 from "./myScore.vue?vue&type=style&index=0&id=82b9eb34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b9eb34",
  null
  
)

export default component.exports